module.exports = __webpack_public_path__ + "static/media/clear.59183159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clear.svg
// module id = 449
// module chunks = 0